import { Grid, Icon, Box } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import { Link } from "react-router-dom";
import SoftBox from "components/SoftBox";

function NoAprobado() {
  return (
    <SoftBox
      sx={{
        border: "2px solid #FFA500", 
        borderRadius: "8px", 
        padding: "20px", 
        maxWidth: "600px", 
        margin: "0 auto", 
        backgroundColor: "#FFF8E1", 
      }}
    >
      <Grid container textAlign={"center"} py={3} pb={2}>
        <Grid item xs={12}>
          <Icon
            sx={{
              width: "50px",
              color: "red",
            }}
          >
            do_not_disturb
          </Icon>
        </Grid>
        <Grid item xs={12} pb={2}>
          <SoftTypography variant="h6">Proveedor no aprobado o documentación vencida.</SoftTypography>
        </Grid>
        <Grid item xs={12}>
          <SoftTypography
            variant="caption"
            component="p"
            color="text"
            sx={{ textAlign: "justify", fontSize: "0.85rem" }}
            mb={2}
          >
            Para poder participar en las cotizaciones, es necesario que su documentación esté al día y haya sido
            aprobada por el área de Compras.
          </SoftTypography>
          <SoftTypography
            variant="caption"
            component="ul"
            color="text"
            sx={{
              textAlign: "justify",
              listStyleType: "disc",
              pl: 3,
              fontSize: "0.85rem",
            }}
            mb={2}
          >
            <li>
              <SoftTypography variant="caption" component="span" color="text" sx={{ fontSize: "0.85rem" }} mb={2}>
                Si ya ha completado la documentación, espere a que sea aprobada, o verifique si está vencida.
              </SoftTypography>
            </li>
            <li>
              <SoftTypography variant="caption" component="span" color="text" sx={{ fontSize: "0.85rem" }} mb={2}>
                Puede seguir el estado de su documentación en la sección &quot;Perfil&quot;.
              </SoftTypography>
            </li>
            <li>
              <SoftTypography variant="caption" component="span" color="text" sx={{ fontSize: "0.85rem" }}>
                Si tiene alguna consulta o necesita asistencia, por favor comuníquese con el área de Administración del Comedor.
                <br />
                Email:{" "}
                <a href="mailto:compras@uprosanluis.edu.ar" style={{ textDecoration: "none", color: "blue" }}>
                  compras@uprosanluis.edu.ar
                </a>
              </SoftTypography>
            </li>
          </SoftTypography>
        </Grid>
      </Grid>
    </SoftBox>
  );
}

export default NoAprobado;
